import React from "react";

const ReportItemList = ({ data, setYear, activeYear, setChart }) => {
  const renderClass = (item) => {
    let _data = activeYear?.half_year;
    let _item = item?.half_year;

    return _item === _data ? "active" : "";
  };

  const getUniqueObjects = () => {
    let tmpObj = {};
    if (data?.data) {
      data?.data[0]?.payables?.forEach(item => tmpObj[item.half_year] = item);
      data?.data[0]?.payments?.forEach(item => tmpObj[item.half_year] = item);
    }
    return Object.values(tmpObj);
  }

  const handleClick = (e) => {
    setChart({});
    setYear(e);
  };

  return (
    <div className="report-item-list">
      <ul>
        {getUniqueObjects().map((item, i) => (
            <li
              key={i}
              onClick={() => handleClick(item)}
              className={renderClass(item)}
            >
              {item.half_year}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default ReportItemList;
